import { FormModal, InputField, View } from "../base";
import { OrganizationCustomVoice } from "../../redux/reducers/organizationCustomVoicesSlice";

type VoiceFormData = {
  name: string;
  description: string;
};

type UpdateCustomVoiceDialogueProps = {
  isOpen: boolean;
  voice: OrganizationCustomVoice | null;
  onClose: () => void;
  onUpdateVoice: (id: string, params: { name: string; description: string }) => void;
};

export const UpdateCustomVoiceDialogue = ({ isOpen, voice, onClose, onUpdateVoice }: UpdateCustomVoiceDialogueProps) => {
  if (!voice) return null;

  const config: VoiceFormData = {
    name: voice.name ?? "",
    description: voice.description ?? "",
  };

  const handleSave = (formData: VoiceFormData) => {
    if (!formData.name.trim()) return;
    onUpdateVoice(voice.id, {
      name: formData.name.trim(),
      description: formData.description.trim(),
    });
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      config={config}
      title="Edit Custom Voice"
      saveLabel="Save Changes"
      className="w-full max-w-md min-w-0 max-h-[90vh] mx-4"
    >
      {({ localConfig, onChange }) => (
        <View className="space-y-4">
          <InputField
            label="Voice Name"
            value={localConfig.name}
            onChange={onChange("name")}
            placeholder="Enter voice name..."
            className="w-full"
          />
          <InputField
            label="Description"
            value={localConfig.description}
            onChange={onChange("description")}
            placeholder="Enter voice description..."
            className="w-full"
          />
        </View>
      )}
    </FormModal>
  );
};
